function toggleSearch() {
  jQuery('#search-overlay').toggleClass('open');
}

jQuery(document).ready(function () {
  jQuery('.top-bar-search-icon').click(function (e) {
    toggleSearch();
  });
  jQuery('.job-search-top-bar-input').click(function (e) {
    if (e.stopPropagation()) {
      e.stopPropagation();
    } else {
      e.cancelBubble = true; //IE 6-8
    }
  });
  jQuery('.search-icon').click(function (e) {
    if (e.stopPropagation()) {
      e.stopPropagation();
    } else {
      e.cancelBubble = true; //IE 6-8
    }
  });
  jQuery('#search-overlay').click(function (e) {
    if (e.target !== jQuery('.searchfield')) {
      toggleSearch();
    }
  });
  jQuery(document).keyup(function (e) {
    if (e.keyCode === 27 && jQuery('#search-overlay').hasClass("open")) {
      toggleSearch();
    }
  });
});
